import React, { useState, useEffect, useContext } from "react";
import Layout from "components/Layout";
import CategorySlider from "components/CategorySlider";
import PopupLayout from "components/PopupLayout";
import PopupWelcome from "components/PopupWelcome";
import CouponSlider from "components/CouponSlider";
import ProcessChange from "components/ProcessChange";
import CartFactory from "factories/Cart";
import CouponService from "services/Coupon/service";
import CartService from "services/Cart/service";
import UserService from "services/User/service";
import { categories_links } from "config";
import { handleize } from "config/utils";
import { AuthContext } from "../../auth/AuthContext";
import { CartContext } from "../../cart/CartContext";
import { types } from "../../types/types";
import PopupUpdateUser from "components/PopupUpdateUser";
import SessionFactory from "factories/Session";


const Home = () => {
    const { sessionData, sessionDispatch } = useContext(AuthContext);
    const { cartDispatch } = useContext(CartContext);
    const [privateCoupons, setPrivateCoupons] = useState([]);
    const [categoriesFormat, setCategoriesFormat] = useState([]);
    const [showWelcome, setShowWelcome] = useState(false);
    const [loginValidation, setLoginValidation] = useState(false);
    const [loginData,setLoginData]=useState();
    const [showWelcomev2,setShowWelcomev2]=useState(false);

   
    const openPopupUpdateUser= () =>{
        //open popup band title end text de checkbox
   
        setLoginValidation(!loginValidation);
        console.log("validate login",loginValidation);
        setShowWelcomev2(showWelcome);
        SessionFactory.setUpdateTries('showUpdateData','true');

    }
    

    const openWelcome = (event, forceValue = "none") => {
        event.preventDefault();
        setShowWelcomev2(forceValue === 'none' ? !showWelcomev2 : (forceValue));
    };

    
    useEffect(() => {
        if (sessionData.welcome) {
            setShowWelcome(true);
            UserService.welcome().then();
            sessionDispatch({
                type: types.change,
                payload: {
                    welcome: false,
                },
            });
        }

        Promise.all([CartService.getLastCart()]).then((couponList) => {
            if (
                couponList &&
                ["200", "201"].includes(couponList[0].internalCode)
            ) {
                localStorage.setItem(
                    "maxLimit",
                    couponList[0].payload.maxItems
                );
                cartDispatch({
                    type: types.update,
                    payload: CartFactory.initLastCart(couponList[0].payload),
                });
                
            } else {
                cartDispatch({
                    type: types.update,
                    payload: CartFactory.reset(),
                });
            }
        });
    }, []);

    useEffect(() => {
        if (sessionData.welcome) {
            return;
        }
        let updatetries=SessionFactory.getUpdateTries('numberTrie');
        let date=SessionFactory.getLoginData();
        let showUpdateData=SessionFactory.getUpdateTries('showUpdateData');
        console.log(showUpdateData);

        
        if(date !==null && date.loginApp.validateUserByDni && !date.loginApp.legalOthers && !showUpdateData){
            if(updatetries < 3){
                setLoginData(date);
                setLoginValidation(true);
            }else{
                setShowWelcomev2(showWelcome);
            }
        }
        else
        {
            setShowWelcomev2(showWelcome);
        }

        Promise.all([CouponService.getListPrivate()]).then((couponList) => {
            if (couponList && couponList[0].coupons) {
                const couponGroups = couponList[0].coupons;
                //console.log(couponGroups);
                //categories format
                const categoriesFound = [];
                categories_links.map((category) => {
                    let isFound = 0;
                    couponGroups.map((group) => {
                        if (
                            handleize(group.option.couponGroupName) ===
                            category.handle
                        )
                            isFound++;
                    });
                    if (isFound > 0) categoriesFound.push(category);
                });
                if (categoriesFound.length > 0)
                    setCategoriesFormat(categoriesFound);

                //coupons format
                const coupons = [];
                couponGroups
                    .filter(
                        (cupon) => cupon.option.couponGroupName !== "ECOMMERCE"
                    )
                    .map((group) => {
                        group.coupons.map((coupon) => {
                            coupons.push(coupon);
                        });
                    });
                //order for properties order
                coupons.sort(function (a, b) {
                    return a.order - b.order;
                });
                //end
                setPrivateCoupons(coupons);
               
               
            }
        });
    }, [sessionData]);
        
    

     const maiorLinesMsg =(coupons)=>{
        let couponsLines=[];
        //count lines+limite+priceMaterial
        coupons.forEach(coupon => {
            let lines=0;
            if(coupon.nivelMaterial==true){
                lines=lines+4;
            }
           
            lines=lines+coupon.messages.message4.length;
            couponsLines.push(lines);
            
        });
        //maior lines
        var maxLines=Math.max(...couponsLines)

        return maxLines;
       
        
        
    };

   



    
    let couponContent = "";
    if (privateCoupons.length > 0)
        couponContent = (
            <CouponSlider
                coupons={privateCoupons}
                noslick={true}
                hasSession={sessionData.logged}
                maiorLinesMsg={maiorLinesMsg(privateCoupons)}
            />
        );



    return (
        <div className="homepage is-logged">
            <Layout>
                <section className="welcome d-md-none">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mt-4 red">
                                    <strong className="red-dark">
                                        {sessionData.logged
                                            ? `¡Hola ${sessionData.firstname}!`
                                            : ""}
                                    </strong>
                                    <br />
                                    ¿Qué cupones quieres usar hoy?
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <CategorySlider categories={categoriesFormat} />
                <section className="coupons">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 mt-4">{couponContent}</div>
                        </div>
                    </div>
                </section>
            </Layout>
            <ProcessChange />
            <PopupLayout isShowwing={showWelcomev2} showingCallback={openWelcome}>
                <PopupWelcome />
            </PopupLayout>
            <PopupLayout isShowwing={loginValidation} showingCallback={openPopupUpdateUser}>
                <PopupUpdateUser execActionConfirm={openPopupUpdateUser} titleText={"Actualizacion de Datos"} popupLegalText={"update"} loginData={loginData}  />
            </PopupLayout>
           
        </div>
    );
};

export default Home;
